package com.appsyde.shared.presentation

import androidx.compose.runtime.Composable
import com.appsyde.shared.app.navigation.AppPaths
import com.appsyde.shared.presentation.screen.screen.ChooseWorkspaceScreen
import com.appsyde.shared.presentation.screen.screen.ConfirmAccountDeletionPage
import com.appsyde.shared.presentation.screen.screen.InviteAcceptPage
import com.appsyde.shared.presentation.screen.screen.LegalPage
import com.appsyde.shared.presentation.screen.screen.NoWorkspaceScreen
import com.appsyde.shared.presentation.screen.screen.PrivacyPage
import com.appsyde.shared.presentation.screen.screen.TermsPage

/**
 * Routes that do not depend on session state. If [pathname] matches one of these,
 * the corresponding screen is composed; otherwise [content] is composed (session-based flow).
 */
@Composable
inline fun StaticRouteOr(pathname: String, content: @Composable () -> Unit) {
    when {
        pathname.contains(AppPaths.CONFIRM_ACCOUNT_DELETION) -> ConfirmAccountDeletionPage()
        pathname.contains(AppPaths.INVITE) -> InviteAcceptPage()
        pathname.contains(AppPaths.PRIVACY) -> PrivacyPage()
        pathname.contains(AppPaths.TERMS) -> TermsPage()
        pathname.contains(AppPaths.LEGAL) -> LegalPage()
        pathname.contains(AppPaths.NO_WORKSPACE) -> NoWorkspaceScreen()
        pathname.contains(AppPaths.CHOOSE_WORKSPACE) -> ChooseWorkspaceScreen()
        else -> content()
    }
}
